module.exports = __webpack_public_path__ + "static/media/trash-icon.184c3dc4.svg";